import MCPIntegration from '@/components/MCPIntegration';
import AITermsConfig from '@/components/AITermsConfig';

export function AiMcpTab({ hotelId }) {
  return (
    <div className="space-y-6" data-testid="owner-ai-mcp-content">
      <div>
        <h2 className="text-2xl font-bold heading-font mb-2">AI & MCP Configuration</h2>
        <p className="text-muted-foreground">Configure AI assistant terms and MCP integration settings</p>
      </div>
      
      <MCPIntegration hotelId={hotelId} />
      <AITermsConfig hotelId={hotelId} />
    </div>
  );
}
